import { cn } from "@nextui-org/react";
import { motion } from "framer-motion";

export const LoadingSpinner = ({ className, size = "default" }) => {
  const sizeClasses = {
    small: "h-4 w-4 border-2",
    default: "h-8 w-8 border-2",
    large: "h-12 w-12 border-3",
  };

  return (
    <div className={cn("flex items-center justify-center min-h-[200px]", className)}>
      <div
        className={cn(
          "animate-spin rounded-full border-fuchsia-500 border-t-transparent",
          sizeClasses[size]
        )}
      />
    </div>
  );
};

export const PageLoader = ({ className }) => {
  return (
    <div className={cn("fixed inset-0 flex justify-center items-center z-50 bg-slate-900", className)}>
      <motion.div
        className="h-20 w-20 flex justify-center items-center"
        animate={{
          scale: [1, 2, 2, 1, 1],
          rotate: [0, 0, 180, 180, 0],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          times: [0, 0.2, 0.5, 0.8, 1],
          repeat: Infinity,
          repeatDelay: 1,
        }}
      >
        <img
          src={window.siteUrl + "/wp-content/plugins/innovative-design/public/logo/symbol.svg"}
          alt="Loading..."
          className="h-full w-full"
        />
      </motion.div>
    </div>
  );
};
